import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { THEME_COLORS } from "../../../../ThemeConfig";
// import successIcon from "../../../../assets/icons/success-tick.svg";
import successIcon from "../../../../assets/icons/payment-success-icon.svg";
import failedIcon from "../../../../assets/icons/payment-faliled.svg";
import { PatientConfig } from "../../../../axiosConfig";
import { Context } from "../../../../contexts/Store";
import BottomNavigation from "../../../general/BottomNavigation";

export default function Transactions() {
    const { state, dispatch } = useContext(Context);
    const access_token = state.user_details.access_token;
    const [transactions, setTransactions] = useState([]);

    function capitalizeFirstLetter(sentence) {
        return sentence.replace(/(^\w{1})|(\.\s+\w{1})/g, (match) =>
            match.toUpperCase()
        );
    }

    const getTransactions = () => {
        PatientConfig.get("/api/v1/patients/patient/payment-history/", {
            headers: {
                Authorization: `Bearer ${access_token}`,
            },
            params: {
                // filter: selectedFilterType,
            },
        })
            .then((response) => {
                const { StatusCode, data } = response.data;
                if (StatusCode == 6000) {
                    setTransactions(data);
                } else if (StatusCode == 6001) {
                    // console.log(error, "error");
                }
            })
            .catch((error) => {
                if (error.response.data.data.message) {
                    alert(error?.response?.data?.data?.message);
                }
            });
    };

    useEffect(() => {
        getTransactions();
    }, []);

    return (
        <>
            <MainContainer>
                <ContentDiv>
                    <PageTitle>Transaction History</PageTitle>
                    {transactions.length > 0 ? (
                        <TransactionCards>
                            {transactions.map((transaction) => (
                                <TransactionCard
                                // status={
                                //     transaction?.is_refund
                                //         ? "refund"
                                //         : transaction?.success
                                //         ? "success"
                                //         : "failed"
                                // }
                                >
                                    <HeadContainer>
                                        <HeadLeft>
                                            <StatusIconContainer
                                                isSuccess={transaction?.success}
                                            >
                                                <StatusIcon
                                                    src={
                                                        transaction?.success
                                                            ? successIcon
                                                            : failedIcon
                                                    }
                                                    alt="icon"
                                                />
                                            </StatusIconContainer>
                                            <ConcernHeadContainer>
                                                <ConcernTitle>
                                                    {transaction?.session_name}
                                                </ConcernTitle>
                                                <ConcernSubTitle>
                                                    {transaction?.case_id}
                                                </ConcernSubTitle>
                                            </ConcernHeadContainer>
                                        </HeadLeft>
                                        {transaction?.is_refund && (
                                            <RefundStatus>Refund</RefundStatus>
                                        )}
                                    </HeadContainer>
                                    <DetailsBox>
                                        <DetailItem>
                                            <DetailGreyText>
                                                Amount:
                                            </DetailGreyText>
                                            <DetailBlackText>
                                                ₹ {transaction?.amount}
                                            </DetailBlackText>
                                        </DetailItem>
                                        <DetailItem>
                                            <DetailGreyText>
                                                Txn ID:
                                            </DetailGreyText>
                                            <DetailBlackText>
                                                {transaction?.transaction_id}
                                            </DetailBlackText>
                                        </DetailItem>
                                        {!transaction.is_refund && (
                                            <DetailItem>
                                                <DetailGreyText>
                                                    Payment type:
                                                </DetailGreyText>
                                                <DetailBlackText>
                                                    {transaction?.payment_type}
                                                </DetailBlackText>
                                            </DetailItem>
                                        )}
                                        <DetailItem>
                                            <DetailGreyText>
                                                Date:
                                            </DetailGreyText>
                                            <DetailBlackText>
                                                {transaction?.date}
                                            </DetailBlackText>
                                        </DetailItem>
                                    </DetailsBox>
                                </TransactionCard>
                            ))}
                        </TransactionCards>
                    ) : (
                        <NoItem>
                            No transactions found. You haven't made any
                            transactions yet.
                        </NoItem>
                    )}
                </ContentDiv>
                <BottomNavigation />
            </MainContainer>
        </>
    );
}

const MainContainer = styled.div`
    width: 100%;
    padding: 20px 0px;
    background: ${THEME_COLORS.page_bg};
    overflow: auto;
    display: flex;
    flex-direction: column;

    align-items: center;
    /* position: relative; */
    /* z-index: -1; */
    @media all and (max-width: 768px) {
        width: 100%;
        padding-bottom: 120px;
    }
    @media all and (max-width: 360px) {
        width: 100%;
        padding-bottom: 90px;
    }
`;
const ContentDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    max-width: 480px;
    background: ${THEME_COLORS.card_bg};
    border: 1px solid ${THEME_COLORS.light_300};
    border-radius: 16px;
    padding: 24px;
    min-height: calc(100vh - 120px);
    overflow-y: auto;
    box-shadow: ${THEME_COLORS.elevation_user_u4};
    @media all and (max-width: 768px) {
        max-width: 94%;
        margin: 0 12px;
    }
    @media all and (max-width: 480px) {
        padding: 20px 16px;
        gap: 20px;
    }
`;
const PageTitle = styled.h1`
    font-size: 24px;
    text-align: center;
    font-family: "DM_sans_medium";
    color: ${THEME_COLORS.secondary};
    margin: 0 0 8px;
    letter-spacing: -0.02em;
`;
const TransactionCards = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
const TransactionCard = styled.div`
    border: 1px solid ${THEME_COLORS.light_300};
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${THEME_COLORS.surface_soft};
    box-shadow: ${THEME_COLORS.elevation_user_u4};
`;
const HeadContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    /* align-items: center; */
    gap: 8px;
`;
const HeadLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;
const RefundStatus = styled.span`
    display: inline-block;
    font-family: "DM_sans_medium";
    font-size: 13px;
    background: ${THEME_COLORS.chips_blue_container};
    color: ${THEME_COLORS.chips_blue_on_container_2};
    padding: 6px 12px;
    border-radius: 20px;
`;
const ConcernHeadContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
`;
const ConcernTitle = styled.span`
    display: inline-block;
    font-size: 16px;
    font-family: "DM_sans_medium";
    color: ${THEME_COLORS.text_title};
`;
const ConcernSubTitle = styled.span`
    font-size: 13px;
    color: ${THEME_COLORS.text_para};
    font-family: "DM_sans";
`;

const TransactionId = styled.span`
    display: inline-block;
`;
const StatusText = styled.span`
    display: inline-block;
`;
const StatusIconContainer = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${(props) =>
        props.isSuccess
            ? THEME_COLORS.chips_green_container
            : THEME_COLORS.chips_red_container};
`;

const StatusIcon = styled.img`
    width: 70%;
    display: block;
`;
const DateText = styled.span`
    display: inline-block;
`;
const DetailsBox = styled.div`
    /* display: grid;
    grid-template-columns: 1fr 1fr; */
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
const DetailItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    /* justify-content: space-between; */
`;
const DetailGreyText = styled.div`
    font-family: "DM_sans";
    font-size: 14px;
    color: ${THEME_COLORS.text_para};
`;
const DetailBlackText = styled.div`
    font-family: "DM_sans_medium";
    font-size: 14px;
    color: ${THEME_COLORS.text_title};
`;
const NoItem = styled.div`
    border: 1px dashed ${THEME_COLORS.light_300};
    min-height: 120px;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "DM_sans";
    font-size: 15px;
    color: ${THEME_COLORS.text_para};
    padding: 24px;
    text-align: center;
    background: ${THEME_COLORS.surface_soft};
`;
